import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function ImprovingConditions(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#6FCF97" fillOpacity="0.4"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.99 6C10.47 6 6 10.48 6 16C6 21.52 10.47 26 15.99 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 15.99 6ZM12.5 12C11.6716 12 11 12.6716 11 13.5C11 14.3284 11.6716 15 12.5 15C13.3284 15 14 14.3284 14 13.5C14 12.6716 13.3284 12 12.5 12ZM19.5 12C18.6716 12 18 12.6716 18 13.5C18 14.3284 18.6716 15 19.5 15C20.3284 15 21 14.3284 21 13.5C21 12.6716 20.3284 12 19.5 12ZM12.55 18C13.25 19.19 14.52 20 16 20C17.48 20 18.75 19.19 19.45 18H21.12C20.32 20.05 18.33 21.5 16 21.5C13.67 21.5 11.68 20.05 10.88 18H12.55ZM8 16C8 20.42 11.58 24 16 24C20.42 24 24 20.42 24 16C24 11.58 20.42 8 16 8C11.58 8 8 11.58 8 16Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
